import styled from 'styled-components';
import { colors } from '~/styles/colors';

export const ExceptionCardRow = styled.div`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  height: 32px;
  width: 709px;
  border-top: 1px solid ${colors.GreyDefaultCardBorder};
  border-right: 1px solid ${colors.GreyDefaultCardBorder};
  border-bottom: 1px solid ${colors.GreyDefaultCardBorder};
  border-left: 10px solid ${colors.Blue300};
  border-radius: 5px;
  margin-left: 10px;
`;

export const FieldTitle = styled.div`
  margin-left: 17px;
  margin-top: 5px;
  font-size: 12px;
  width: 151px;
  font-weight: bold;
`;

export const FieldDate = styled.div`
  margin-left: 74px;
  margin-top: 5px;
  font-size: 12px;
  width: 90px;
`;

export const FieldRepeat = styled.div`
  margin-left: 13px;
  margin-top: 5px;
  font-size: 12px;
  width: 70px;
`;

export const FieldBeginTime = styled.div`
  margin-left: 20px;
  margin-top: 5px;
  font-size: 12px;
  width: 52px;
`;

export const FieldEndTime = styled.div`
  margin-left: 10px;
  margin-top: 5px;
  font-size: 12px;
  width: 52px;
`;

export const ButtonContainer = styled.div`
  margin-left: 12px;
  margin-top: 3px;
  cursor: pointer;
`;

export const TooltipContent = styled.span`
  margin-top: 6px;
  font-size: 95%;
`;

export const IconWrapper = styled.div`
  display: inline-block;
  width: 14px;
  height: 15px;
  text-align: center;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  svg {
    width: 14px;
    height: 15px;
  }
`;
